import React from 'react';
import { useSelector } from 'react-redux';
import { currentUser } from 'redux/session/selectors';
import { selectSuccess, selectSubmitting } from 'redux/announcement/selectors';
import { useFormik } from 'formik';
import AddAnnouncementForm from './AddAnnouncementForm';
import { AnnouncementSchema } from '../../../../utilities/validation';
import { AddAnnouncementRequest } from 'redux/announcement/types';
import { getNewDate } from 'utilities/helper.util';

interface IProps {
  handleCancel: Function;
  handleOnSubmit: Function;
  editId: number;
  editData: Object;
}

const initializeWith = (data: any) => {
  return data && Object.keys(data).length !== 0
    ? {
        ...data,
        startAt: getNewDate(data.startAt).format('YYYY-MM-DD'),
        startAtDateTime: data.startAt,
        startAtTime: getNewDate(data.startAt).format('h:mm'),
        startAtAMPM: getNewDate(data.startAt).format('A'),
        endAt: getNewDate(data.endAt).format('YYYY-MM-DD'),
        endAtDateTime: data.endAt,
        endAtTime: getNewDate(data.endAt).format('h:mm'),
        endAtAMPM: getNewDate(data.endAt).format('A'),
        targetOrganisations: data?.Organisations?.map((org: any) => org.id)
      }
    : {
        title: '',
        text: '',
        category: '',
        toggleActionButton: false,
        callToActionLabel: '',
        callToActionLink: '',
        startAt: '',
        startAtDateTime: '',
        startAtTime: '12:00',
        startAtAMPM: 'AM',
        endAt: '',
        endAtDateTime: '',
        endAtTime: '11:59',
        endAtAMPM: 'PM',
        icon: '',
        isUserAbleToHide: false,
        targetRoles: '',
        targetOrganisations: '',
        noticeType: '',
        selectedOrganisations: ''
      };
};

const AddAnnouncement: React.FC<IProps> = ({
  handleCancel,
  handleOnSubmit,
  editId,
  editData
}) => {
  const isSuccess: boolean = useSelector(selectSuccess);
  const isSubmittingForm: boolean = useSelector(selectSubmitting);

  const { id } = useSelector(currentUser);

  const formik = useFormik({
    initialValues: initializeWith(editData),
    validationSchema: AnnouncementSchema,
    onSubmit: (values: any) => {
      const addAnnouncementObject: AddAnnouncementRequest = {
        title: values.title,
        text: values.text,
        category: values.category,
        callToActionLabel: values.callToActionLabel,
        callToActionLink: values.callToActionLink,
        startAt: values.startAtDateTime,
        endAt: values.endAtDateTime,
        icon: values.noticeType === 'MEMBER' ? 'Information' : values.icon,
        isUserAbleToHide:
          values.noticeType === 'MEMBER' ? true : values.isUserAbleToHide,
        userId: id,
        targetRoles:
          values.noticeType === 'MEMBER'
            ? ['SYSADMIN', 'AOADMIN', 'ENQUIRER', 'DBYDADMIN']
            : values.targetRoles,
        noticeType: values.noticeType,
        organisations:
          values.noticeType === 'MEMBER'
            ? values.targetOrganisations.map((orgId: number) => {
                return {
                  id: orgId
                };
              })
            : undefined
      };
      handleOnSubmit(addAnnouncementObject);
    }
  });

  return (
    <div className={'announcement-modal display-block'}>
      <section className="announcement-modal-main">
        <AddAnnouncementForm
          formik={formik}
          isSubmittingForm={isSubmittingForm}
          isSuccess={isSuccess}
          handleCancel={handleCancel}
          editId={editId}
          editData={editData}
        />
      </section>
    </div>
  );
};

AddAnnouncement.displayName = 'AddAnnouncement';
export default AddAnnouncement;
